/**
 * - Midnight Blue is our primary "brand" color
 * - Used across all interactive elements such as buttons, links, inputs, etc.
 * - This color can define the overall feel and can elicit emotion
 */
export const Midnight = {
    100: "#003349",
    90: "#1A475B",
    80: "#335C6D",
    70: "#4D7080",
    60: "#668592",
    50: "#8099A4",
    40: "#99ADB6",
    30: "#B2C2C8",
    20: "#CCD6DB",
    10: "#E5EBED",
    4: "#F5F7F8",
    2: "#FBFBFC",
}

/**
 * - As a neutral color and Warm BlackDusk is a big part of the color system.
 * - Everything in UI design — text, form fields, backgrounds, dividers — are usually some shade of gray
 */
export const Dusk = {
    100: "#2C3439",
    90: "#3F464A",
    80: "#51585C",
    70: "#64696D",
    60: "#707579",
    50: "#888C8E",
    40: "#9B9EA0",
    30: "#AEB1B2",
    20: "#C0C1C2",
    10: "#D2D4D5",
}

/**
 * Gulf Blue is a secondary accent color to be used sparingly in subtle ui elements
 */
export const Gulf = {
    100: "#007F90",
    90: "#1A8C9B",
    80: "#3399A6",
    70: "#4DA5B1",
    60: "#66B2BC",
    50: "#80BFC7",
    40: "#99CCD3",
    30: "#B3D9DE",
    20: "#CCE5E9",
    10: "#E6F2F4",
}

/**
 * Tetons Gray is a secondary accent color to be used sparingly in subtle ui elements
 */
export const Tetons = {
    100: "#9EB3B3",
    90: "#A8BBBB",
    80: "#B1C2C2",
    70: "#BBCACA",
    60: "#C5D1D1",
    50: "#CED9D9",
    40: "#D8E1E1",
    30: "#E2E8E8",
    20: "#ECF0F0",
    10: "#F5F7F7",
}

/**
 * - Key-West Yellow is used for the primary cta throughout the main consumer website and digital touchpoints.
 * - Use this sparingly as it ties back to the lasting old brand but also utilize for primary button actions
 */
export const KeyWest = {
    100: "#FFD000",
    90: "#FFD51A",
    80: "#FFD933",
    70: "#FFDE4D",
    60: "#FFE366",
    50: "#FFE780",
    40: "#FFEC99",
    30: "#FFF1B3",
    20: "#FFF6CC",
    10: "#FFFAE6",
}

/**
 * Hilton Head Sand is a secondary accent color to be used sparingly in subtle ui elements
 */
export const Sand = {
    100: "#E6E3D6",
    90: "#E8E6DA",
    80: "#EBE9DE",
    70: "#EEEBE2",
    60: "#F0EEE6",
    50: "#F2F1EA",
    40: "#F5F4EF",
    30: "#F8F7F3",
    20: "#FAF9F7",
    10: "#FCFCFB",
}

/**
 * Aspen Green is a secondary accent color to be used sparingly in subtle ui elements
 */
export const Aspen = {
    100: "#99A98A",
    90: "#A3B296",
    80: "#ADBAA1",
    70: "#B8C3AD",
    60: "#C2CBB9",
    50: "#CCD4C4",
    40: "#D6DDD0",
    30: "#E0E5DC",
    20: "#EBEEE8",
    10: "#F5F6F3",
}

/**
 * Laguna Sunset is a secondary accent color to be used sparingly in subtle ui elements
 */
export const Laguna = {
    100: "#EF7831",
    90: "#F18546",
    80: "#F2935A",
    70: "#F4A16F",
    60: "#F5AE83",
    50: "#F7BB98",
    40: "#F9C9AD",
    30: "#FAD7C1",
    20: "#FCE4D6",
    10: "#FDF2EA",
}

/**
 * - Error colors are used across error states and in "destructive" actions.
 * - They communicate a destructive/negative action, such as removing a user from your team.
 * - Only use error colors in UI to communicate an error (i.e. this is should not be used prominently in a large block of color)
 */
export const Amaranth = {
    100: "#D62E4F",
    70: "#E97175",
    40: "#F2AEB0",
    10: "#FCEBEB",
}

/**
 * - Success colors communicate a positive action, postive trend, or a successful confirmation.
 * - If you're using green as your primary color, it can be helpful to introduce a different hue for your success green.
 */
export const MintGreen = {
    100: "#6BA342",
    70: "#97BE7A",
    40: "#C4DAB3",
    10: "#F0F5EC",
}

/**
 * - Warning colors can communicate that an action is potentially destructive or "on-hold".
 * - These colors are commonly used in confirmations to grab the users' attention.
 */
export const OrangeYellow = {
    100: "#DDAD49",
    70: "#E7C57F",
    40: "#F1DEB6",
    10: "#FBF6EC",
}

/**
 * - Lake / Link is use only when indicating a link color on a light background.
 * - Avoid using on small body copy. It can be used on UI components and larger text.
 */
export const LakeBlue = {
    100: "#0078AB",
    70: "#4CA0C4",
    40: "#7FBBD5",
    10: "#E5F1F6",
}

export const EverGreen = {
    100: "#557263",
}

export const WarmBlack = { 
    100: "#27221D"
}
